import { render, staticRenderFns } from "./TheDocumentsTable.vue?vue&type=template&id=58620d1a&"
import script from "./TheDocumentsTable.vue?vue&type=script&lang=ts&"
export * from "./TheDocumentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports